'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _kebabCase2 = require('lodash/kebabCase');

var _kebabCase3 = _interopRequireDefault(_kebabCase2);

var _result2 = require('lodash/result');

var _result3 = _interopRequireDefault(_result2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var RadioButtonGroup = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(RadioButtonGroup, _Component);

  function RadioButtonGroup() {
    _classCallCheck(this, RadioButtonGroup);

    return _possibleConstructorReturn(this, (RadioButtonGroup.__proto__ || Object.getPrototypeOf(RadioButtonGroup)).apply(this, arguments));
  }

  _createClass(RadioButtonGroup, [{
    key: 'handleRadioClick',
    value: function handleRadioClick(event) {
      var _props = this.props,
          handleRadioClick = _props.handleRadioClick,
          fieldName = _props.fieldName;

      handleRadioClick(event.currentTarget.value, fieldName);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          checker = _props2.checker,
          condensed = _props2.condensed,
          descriptionLookupString = _props2.descriptionLookupString,
          fieldName = _props2.fieldName,
          items = _props2.items,
          lookupString = _props2.lookupString,
          title = _props2.title,
          twoColumns = _props2.twoColumns,
          listClassNames = (0, _classnames2.default)('radio-buttons', { 'condensed': !!condensed }, { 'two-columns': !!twoColumns });


      return _react2.default.createElement(
        'div',
        { key: title, className: 'radio-group' },
        title && _react2.default.createElement(
          'h5',
          null,
          title.toUpperCase()
        ),
        _react2.default.createElement(
          'ul',
          { className: listClassNames },
          items.map(function (item) {
            var value = (0, _result3.default)(item, lookupString),
                description = (0, _result3.default)(item, descriptionLookupString),
                uniqueKey = (0, _kebabCase3.default)(fieldName + '_' + value);

            return _react2.default.createElement(
              'li',
              { key: value },
              _react2.default.createElement('input', {
                checked: checker === value,
                id: uniqueKey,
                onChange: _this2.handleRadioClick,
                type: 'radio',
                value: value
              }),
              _react2.default.createElement(
                'label',
                { htmlFor: uniqueKey },
                description
              )
            );
          })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return RadioButtonGroup;
}(_react.Component), _class2.defaultProps = {
  descriptionLookupString: 'name',
  lookupString: 'value'
}, _class2.propTypes = {
  checker: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  condensed: _propTypes2.default.bool,
  descriptionLookupString: _propTypes2.default.string,
  fieldName: _propTypes2.default.string.isRequired,
  handleRadioClick: _propTypes2.default.func.isRequired,
  items: _mobxReact.propTypes.arrayOrObservableArray.isRequired,
  lookupString: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string,
  twoColumns: _propTypes2.default.bool
}, _temp)) || _class) || _class;

var _default = RadioButtonGroup;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(RadioButtonGroup, 'RadioButtonGroup', '/app/src/components/common/RadioButtonGroup.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common/RadioButtonGroup.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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